import { client, gql } from 'data-provider';

export interface Organization {
  id: string;
  name: string;
  displayName: string;
  phone: string;
  contact: string;
  address: string;
}

export const getOrganizations = async () => {
  const query = gql`
    query {
      getOrganizations {
        id
        name
        display_name
        phone
        contact
        address
      }
    }
  `;

  const data = await client.request(query);

  return data.getOrganizations.map(
    (org: Omit<Organization, 'displayName'> & { display_name: string }) => {
      const { display_name, ...rest } = org;
      return { ...rest, displayName: display_name };
    }
  ) as Organization[];
};

export const createOrganization = async (data: Omit<Organization, 'id' | 'displayName'>) => {
  const mutation = gql`
    mutation ($input: CreateOrganizationInput!) {
      createOrganization(input: $input) {
        id
        name
        display_name
        phone
        contact
        address
      }
    }
  `;

  const variables = {
    input: { data },
  };

  const createdData = await client.request(mutation, variables);
  const { display_name, ...rest } = createdData.createOrganization;
  return { ...rest, displayName: display_name } as Organization;
};

export const updateOrganization = async (
  orgId: string,
  data: Partial<Omit<Organization, 'id' | 'displayName'>>
) => {
  const mutation = gql`
    mutation ($input: UpdateOrganizationInput!) {
      updateOrganization(input: $input) {
        organization {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id: orgId },
      data,
    },
  };

  const updatedData = await client.request(mutation, variables);
  return updatedData.updateOrganization as { organization: { id: string } };
};

export const deleteOrganization = async (orgId: string) => {
  const mutation = gql`
    mutation ($input: DeleteOrganizationInput!) {
      deleteOrganization(input: $input) {
        organization {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id: orgId },
    },
  };

  await client.request(mutation, variables);
};
